import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import axiosInstance from '../../network/ApiCall';
import LoadingSpinner from '../widgets/LoadingSpinner';
import { useTranslation } from 'react-i18next';
import {SYSTEM_UNION_CODE} from "../../config";
import {useSelector} from "react-redux";


function CountriesTable() {

  const { t } = useTranslation();
  const authState = useSelector((state) => state.auth);

  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tableLoading, setTableLoading] = useState(true);

  const unionModeEnabled = Boolean(SYSTEM_UNION_CODE);
  const isUnionAdmin = authState?.user?.roles?.includes('UNION_ADMIN');
  const shouldShowRefresh = !unionModeEnabled || isUnionAdmin;

  const getCountries = (page) => { 
    setTableLoading(true)
    axiosInstance.get("/country")
      .then(response => {
        setCountries(response.data);
        setLoading(false);
        setTableLoading(false)
      })
      .catch(error => {
        setCountries({});
        setLoading(false);
        setTableLoading(false)
      })
  }

  const refreshCountries = () => {
    setTableLoading(true)
    axiosInstance.get("/country/updateCountries")
      .then(response => {
        getCountries(1);
        setLoading(false);
        setTableLoading(false)
      })
      .catch(error => {
        setCountries({});
        setLoading(false);
        setTableLoading(false)
      })
  }

  const handlePageChange = page => {
    getCountries(page);
  };

  const columns = [
    {
      name: t('countriesPage:lblIsocode2'),
      selector: row => row.isoCode2,
      sortable: true,
    },
    {
      name: t('countriesPage:lblIsocode3'),
      selector: row => row.isoCode3,
      sortable: true,
    },
    {
      name: t('countriesPage:lblLabel'),
      selector: row => t('countries:' + row.isoCode2),
      sortable: false,

    },
    {
      name: t('countriesPage:lblUnionCode'),
      selector: row => row.unionCode ? row.unionCode : '',
      sortable: true,
    },
    {
      name: t('countriesPage:lblCustomsAdministrationName'),
      selector: row => row.customsAdministrationName ? row.customsAdministrationName : '',
      sortable: true,
    },
    {
      name: t('countriesPage:lblCustomsAdministrationLogo'),
      selector: row => row.customsAdministrationLogoUrl ? row.customsAdministrationLogoUrl : '',
      sortable: true,
    }
  ];

  useEffect(() => {
    getCountries(1);
  }, []);

  const confirmRefreshCountries = () => {
    // eslint-disable-next-line no-restricted-globals
    if (confirm((t('common:msgAreYouSure')))) {
      refreshCountries();
    }
  }

  return (

    <div className="card h-md-100">
      <div className="card-header bg-light ">
        <div className="row">
          <div className="col">
            <h4>Countries {!loading ? '(' + countries.length + ')' : null}</h4>
          </div>
          {shouldShowRefresh && (
          <div className="col-auto text-center pe-card">
            <button className="btn btn-outline-warning" disabled={tableLoading} onClick={confirmRefreshCountries}>{t('countriesPage:btnReload')}</button>
          </div>
          )}
        </div>

      </div>
      <div className="card-body p-1 mb-5">
        {loading ? <LoadingSpinner /> :
          <>
            <DataTable
              noHeader={true}
              columns={columns}
              data={countries}
              striped={true}              
              progressPending={tableLoading}
              onChangePage={handlePageChange}
            />
          </>
        }

      </div>
    </div>);
}

export default CountriesTable;